module.exports = __webpack_public_path__ + "img/radiator.e4b8362b.svg";